module.exports = __webpack_public_path__ + "static/media/undefined.1d068ff1.png";